<template>
  <layout-vertical>
    <router-view :key="$route.fullPath" />

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->

    <div slot="breadcrumb">
      <app-breadcrumb />
    </div>

    <div slot="footer">
      <app-footer />
    </div>
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import { payboxConfiguration, payboxCommands } from '@/mixins'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from '../components/Navbar.vue'
import AppFooter from '../components/AppFooter.vue'

export default {
  components: {
    // AppCustomizer,
    AppBreadcrumb,
    LayoutVertical,
    Navbar,
    AppFooter,
  },
  mixins: [payboxConfiguration, payboxCommands],
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
